<template>
  <div v-if="videoIdentStore.additionalInvitations.loading">
    {{ $t("additionalInvitations.loading.text") }}
  </div>
  <div v-else-if="videoIdentStore.additionalInvitations.numEids > 0">
    {{
      $t("additionalInvitations.withEids.intro", videoIdentStore.additionalInvitations.numEids)
    }}
    <FormSpacer />
    <b>{{
      $t(
        "additionalInvitations.withEids.tableExplanation",
        videoIdentStore.additionalInvitations.numEids
      )
    }}</b>
    <FormSpacer />
    <table
      class="table table-sm"
      style="width: 100%"
      :aria-label="$t('additionalInvitations.table.description')"
    >
      <thead>
        <tr style="border-bottom: 1pt solid grey">
          <th scope="col">{{ $t("additionalInvitations.table.header.name") }}</th>
          <th scope="col">{{ $t("additionalInvitations.table.header.email") }}</th>
          <th scope="col">{{ $t("additionalInvitations.table.header.subject") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(eId, index) in videoIdentStore.additionalInvitations.furtherEids"
          style="border-bottom: 1pt solid grey"
          :key="index"
        >
          <td>{{ eId.firstName }} {{ eId.lastName }}</td>
          <td>{{ eId.mailto }}</td>
          <td>{{ $t("additionalInvitations.table.body.subject") }}</td>
        </tr>
      </tbody>
    </table>
    <FormSpacer />
    {{
      $t(
        "additionalInvitations.withEids.infoByEmail",
        videoIdentStore.additionalInvitations.numEids,
        { email: videoIdentStore.additionalInvitations.mailto }
      )
    }}
    <FormSpacer />
    <h6>
      <div
        v-if="videoIdentStore.additionalInvitations.emailSendProgress === 'not started'"
      >
        {{
          $t(
            "additionalInvitations.button.invitationMailsSending",
            videoIdentStore.additionalInvitations.numEids
          )
        }}
      </div>
      <div
        v-else-if="videoIdentStore.additionalInvitations.emailSendProgress === 'success'"
      >
        {{
          $t(
            "additionalInvitations.button.invitationMailsSent",
            videoIdentStore.additionalInvitations.numEids
            )
        }}
        {{ $t('additionalInvitations.button.close') }}
      </div>
      <div v-else>
        <!-- {{
          $t(
            "additionalInvitations.button.invitationMailsFailure",
            videoIdentStore.additionalInvitations.numEids
          )
        }} -->
        <i18n-t keypath="additionalInvitations.button.invitationMailsFailure" :plural="videoIdentStore.additionalInvitations.numEids" tag="p" scope="global">
          <template v-slot:supportLink>
            <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('additionalInvitations.error.supportLink')">{{ $t("additionalInvitations.error.support") }}</a>
          </template>
        </i18n-t>
      </div>
    </h6>
  </div>
  <div v-else-if="videoIdentStore.additionalInvitations.errors.length">
    <p>
      <!-- {{ $t("additionalInvitations.error.noMatch") }} -->
      {{ $t("additionalInvitations.error.noMatchButShowSuccess") }}
    </p>
    <div class="h6">
      {{ $t("additionalInvitations.button.close") }}
    </div>
  </div>
  <div v-else>
    <div class="hreg--card-info">
      <CardBody>
        <p>{{ $t("videoIdentification.introTextDev") }}</p>
      </CardBody>
    </div>
  </div>
</template>

<script setup>
import CardBody from "@/components/CardBody.vue";

import { useAppStore } from "@/store/AppStore";
import FormSpacer from "@/components/form/FormSpacer.vue";
const appStore = useAppStore();
appStore.activeStep = appStore.isInvitedUser ? 2 : appStore.screenNumbers.furtherInformation + 1;
// TODO understand why this second variable exists
appStore.activeStepInvite = 2;
appStore.header = "videoIdentification.title";

import { useVideoIdentStore } from "@/store/VideoIdentStore";
import { onBeforeMount } from "vue";
const videoIdentStore = useVideoIdentStore();

onBeforeMount(() => {
  videoIdentStore.fetchAdditionalInvitations();
  videoIdentStore.sendFurtherInvitations();
})

</script>

<style scoped>
.centerIcon {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.d--info-popover {
  color: #fff;
  background-color: #fff;
}
.card-body {
  padding: 1rem;
  padding-top: 2rem;
}
.mdi-alert-circle {
  color: #f29800;
}
.pointer{
  cursor: pointer;
}
</style>
